import styles from "./meetingstandupvideo.module.scss";
import React, { useEffect, useState } from 'react';
import { Dropdown, Modal, Input, Tooltip, Select } from "antd";
import { URInput } from "../../../../shared/widgets/input";
import { URCheckBox } from "../../../../shared/widgets/checkbox";
import { URButton } from "../../../../shared/widgets/button";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import store from "../../../../context/store/store";
import { bytesToSize, getCookie } from "../../../../base/utils";
import { copyLink, downloadFile, finalShare, getDuration, searchHandler, searchHighlight, toastInformation, updateCCToast, userStatusColor,VideoRecordDelete } from "../../../../base/callService/common";
import _ from "lodash";
import { SocketChatService } from "../../../../base/socketChatService";
import { userInfo } from "../../../../base/socketChatService/utils";
import axios from "axios";
import { title } from "process";
import { copyTemplate } from "../../../../base/meetingService/utils";
import { useSelector } from "react-redux";
import { config } from "../../../../base/constant";
import { saverecordlist, shareRedux } from "../../../../base/socketChatService/newChat";
const { Option } = Select;
type recordstate ={
  allContacts: any;
  favouriteContacts: any;
  searchKey: string;
  shareUrl: any;
  shareContact: any;
  isShareModal:any;
  searchIcon:boolean;
  searchVal:string;
  shareCon:any;
  message:string;
  deleteRecordModal:boolean;
  tempfilteredContacts:any
  };

export default function MeetingStandupVideo() {
  let {contactReducer }: any = useSelector((state: any) => state);

  let { workContacts, favContacts,shareDetails, teamContacs  } = contactReducer;
  const [recPart, setRecPart] = useState([]);
  const {recordDetailPage,recShare} = store.getState().meetingReducer || [];
  const [getrecData, setRecData] = useState<recordstate>({
   allContacts: [], favouriteContacts: favContacts, searchKey: "", shareUrl: [], shareContact: [],
 isShareModal: false, message:"" ,tempfilteredContacts:[],
    searchIcon:false , searchVal: "", shareCon: [],deleteRecordModal:false
  });

  useEffect(() => { 
    let uniqueTeamContact: any = _.uniqBy(teamContacs, 'team_id');
    let allContactsList:any  =  [...workContacts, ...uniqueTeamContact]
    if (!_.isEmpty(recordDetailPage)){setRecPart(JSON.parse(recordDetailPage.urmeet_user_list));}
    setRecData({...getrecData,isShareModal : recShare,allContacts : allContactsList,tempfilteredContacts:allContactsList})
    const video:any = document.getElementById('myVideo');
  const newSrc = recordDetailPage?.record_url;
 if(video) {video.src = newSrc;
  video.load();}
  }, [recordDetailPage?.meeting_id,recShare])

  const outPutLangSelection = (
    <>
      <div className={styles.autoTranslateLangs}>
        <span className={styles.topsecTxtTitle}>Record Spoken language</span>
        <div className={styles.searchBox}><URInput placeHolder='Search' className='searchBoxlanglist' /></div>
        <ul className={`scroller ${styles.langList}`}>
          <li className={styles.selected}><span className="icon_tick"></span> Global English (en) - default</li>
          <li><span className="icon_tick"></span> Spanish (es)</li>
          <li><span className="icon_tick"></span> French (fr)</li>
          <li><span className="icon_tick"></span> Portuguese (pt)</li>
          <li><span className="icon_tick"></span> Japanese (ja)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
        </ul>
        <div className={`customchecksize ${styles.bottomFooterSec}`}>
          <URCheckBox /><span className={styles.saveTxttop}>Save for future</span>
        </div>
      </div>
    </>
  );


  const selectContact = (val: any, obj: any) => {
    var filtered_array = [];
    let workContactList: any = workContacts;
    var teammembersdetails: any = [];
    var arr: any = [];
    var checkVal: any;
    let teamList:any = contactReducer.teamContacs;
    try {
      for (var i = 0; i < obj.length; i++) {
        let data: any = JSON.parse(obj[i].key);
        checkVal = data;
       if(data.sip_login_id) {
          let item = {
            chattype:"one",
            sipid: data.sip_login_id,
            name: data.caller_id,
            ext: data.ext.toString(),
            profile_img: data.ImageURL,
            email: data.email_id,
            roletype: 3,
            user_type: "company"
          };
          filtered_array.push(item);         
        }
        else if (data.team_id) {
          let test = _.find(teamList,function(user:any){
            if(user.team_id === data.team_id)
            {

              let item = {
                team_id: data.team_id.toString(),
                name: data.team_name,
                profile_img: data.profile_image_url,
                roletype: 3,
                user_type: "company",
                chattype:"group"
              };
              arr.push(item)
            }
          })
        }
      };
      setRecData({ ...getrecData, shareContact: (filtered_array && arr ) ? filtered_array.concat(arr):(filtered_array && (!arr)) ?filtered_array :arr, shareCon: val ,allContacts : getrecData.tempfilteredContacts, searchKey: ""});
    }
    catch (e: any) {
      console.log("selectBoxOnchange >>>>>", e)
    }
  }
  const shareFile = () => {
    setRecData({ ...getrecData,shareContact: [], shareCon: [],message:""});
    shareRedux(recordDetailPage,true);
      }

      const cancelShare=()=>{
        setRecData({ ...getrecData,shareContact: [], shareCon: [],message:"",allContacts:getrecData.allContacts,searchKey:""});
        shareRedux(shareDetails,false);
      }

  let resContact: any = searchHandler(getrecData.allContacts, getrecData.searchKey);
  let len = resContact?.length > 7 ? Math.round((resContact?.length / 8)) : 1 ;
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  const searchContact = (e: string) => {
    let searchName = e.toLowerCase();
    if (searchName !== "") {
      let contactList: any = (_.isEmpty(getrecData.allContacts) || getrecData.allContacts.length !== 0) ? getrecData.tempfilteredContacts : getrecData.allContacts;
      let filtered = _.filter(contactList, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      // let filteredFav = _.filter(favContacts, function (name: any) {
      //   return name.caller_id?.toLowerCase().includes(searchName) ||
      //     name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
      //     name.email_id?.toLowerCase().includes(searchName);
      // });
      setRecData({ ...getrecData, allContacts: filtered, searchKey: searchName, favouriteContacts: favContacts });
    }
    else { setRecData({ ...getrecData, allContacts: getrecData.allContacts, searchKey: searchName, favouriteContacts: favContacts }); }
  };

  const shareFileRec=()=>{
    
  const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;

    let token: any = getCookie("ssoToken");
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };

    fetch(recordDetailPage?.record_url).then(response=>response.blob())
    .then(blob=>{
      const formData = new FormData();
      formData.append("doc", blob, recordDetailPage?.meeting_name);
      axios
        .post(url, formData, { headers: authkey })
        .then((response: any) => {
          finalShare(response.data.files, getrecData.shareContact,recordDetailPage?.meeting_name,getrecData.message);
        })
    })
    shareRedux(shareDetails,false);
    setRecData({ ...getrecData, isShareModal: false ,shareContact: [], shareCon: [],message:""});

   
  }


  const enterMessage=(e:any)=>{
    setRecData({ ...getrecData, message :e.target.value})
  }
  
  const DeleteRecord =() =>{
    // VideoRecordDelete();
    setRecData({...getrecData, deleteRecordModal:false})
 
  }

  const confirmDelete = () => {
    setRecData({...getrecData, deleteRecordModal:true})
  };
  const closeSelection = () => {
     let deletedArray: any = [];

    // store.dispatch({
    //   type: Types.RECORD_DETAIL_PAGE,
    //   payload: { recordDetailPage: deletedArray }
    // });
    setRecData({...getrecData, deleteRecordModal:false})
  };
  return (
    <>
      <div className={styles.mainInnerConSec}>
        <div className={styles.meetingvideostanup}>
          <div className={styles.topstanuphead}>
            <URButton className='urButton buttonWhite buttonSm' onClick={()=>downloadFile(recordDetailPage)} name='Download' />
            <URButton className='urButton buttonBlue buttonSm' onClick={shareFile} name='Share' />
            <ul>
              <Tooltip placement="top" title="Copy Link">
                <li><span className={`icon_linkrotate ${styles.listattchdelete}`} onClick={()=>copyLink(recordDetailPage?.record_url)} ></span></li>
              </Tooltip>
              <Tooltip placement="top" title="Delete">
                <li><span className={`icon_delete ${styles.listattchdelete}`} onClick={confirmDelete} ></span></li>
              </Tooltip>
            </ul>
          </div>
          <div className={styles.chatinnervideoconsec}>
             <div className={` ${styles.videoMsg}`}>
              <video className="videoFluidone"  controls={true} preload="metadata" 
              src={recordDetailPage?.record_url} id="myVideo">
              </video>
                {/* <div className={styles.playerContainer}>
          <div className={styles.controlSmall}>
            <div className={styles.durationVideo}>{videoState.pausePlay ? currentduration : videoState.duration}</div>
          </div> */}
          {/* <div className={styles.videoProgress}>
                      <div className={styles.progressIndicator}></div>
                      <div className={styles.videoProgressFilled}></div>
                    </div> */}
                    {/* min={1} max={videoState.playerIndex} onChange={player_Onchange}*/}
          {/* <Slider defaultValue={0} value={seektime} tooltipVisible={false}  
          min={0} max={Math.round(duration)} onChange={player_Onchange}
              className="videoSlider" 
            />
        </div> */}
          
            
            </div>
            {/* <div className={styles.langTextMain}>
              <div className={styles.langText}>
              </div>
              <div className={styles.langText}>            
              </div>
            </div> */}
          </div>

          <div className={styles.mildleinnersec}>
            <div className={styles.formGroup} >
              <div className={`${styles.rowFlex} ${styles.alignItemCenter} `}>
                <div className={styles.twelve}>
                  <div className={styles.topdesignhead}>
                    <h4 >{recordDetailPage?.meeting_name}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.formGroup} ${styles.marBtmmed} ${styles.marBtmnon}`}>
              <div className={`${styles.rowFlex} ${styles.alignItemCenter} `}>
                <div className={`${styles.leftsec} ${styles.leftconlist}`}>
                  <div className={styles.meetststxtprop}>
                    <div className={styles.left}>
                      <span className={styles.meetIdsectxt}>Meeting ID</span>
                    </div>
                    <div className={styles.right}>
                      <span className={styles.meetRigtxt}>{recordDetailPage?.meeting_id}</span>
                    </div>
                  </div>
                  <div className={styles.meetststxtprop}>
                    <div className={styles.left}>
                      <span className={styles.meetIdsectxt}>Time & Size</span>
                    </div>
                    {recordDetailPage && <div className={styles.right}>
                      <span className={styles.meetRigtxt}>{getDuration(recordDetailPage?.duration)}
                        <span className={styles.doticon}>&bull;</span>{bytesToSize(recordDetailPage?.record_size)}</span>
                    </div>}
                  </div>
                  <div className={styles.meetststxtprop}>
                    <div className={styles.left}>
                      <span className={styles.meetIdsectxt}>Participants</span>
                    </div>
                    {recPart && recPart.map((part:any,index:any)=>{
                     return ( <div className={styles.right} key={index}>
                       <p className={`${styles.tokentxt} ${styles.marBtmnon}`}><span>{part.name}</span>
                        </p>
                      </div>)
                    })
                   }
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
{/*       <div className={styles.designteampopup}>
        <div className={styles.leftimg}>
          <img src={DesignImg} />
          <span className="icon_tick"></span>
        </div>
        <div className={styles.right}>
          <h4>Design team stand-up.mp4</h4>
          <p className={styles.filesize}>0 MB of 35.7MB mp4</p>
          <div className={styles.bottom}>
            <div className={styles.myProgress}>

            </div>
            <p className={styles.two}><span className={styles.file}>Open File</span>
              <span className={styles.folder}>Open containing folder</span></p>
          </div>


        </div>
        <div className={styles.closeicon}>
          <span className="icon_close"></span>
        </div>
      </div> */}





      <Modal visible={recShare} title="Share this recorded video"
        centered
        maskClosable={false}
        onOk={shareFileRec}
        onCancel={cancelShare}
        cancelText="Cancel"
        okText="Share"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: getrecData.shareContact.length !== 0 ? 'urButton buttonBlue' : 'urButton buttonBlue disabled' }} className="customPopup borderbdm">
        <div className={styles.shareSelect}>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            filterOption={false}
            className="newselects taskcreations customdropbox inputselectlftnone"
            dropdownClassName="newChatSel meetingdropdown"
            showSearch={true}
            onSearch={searchContact}
            placeholder="No assignee"
            onChange={selectContact}
            value={getrecData.shareCon}

          >
            {(favContacts?.length > 0) &&
              <div className="titlesdrop">Favourite / Frequently Contacted</div>}
            {favContacts?.map((favcontactName: any, index: any) => {

              return <div key={index} value={favcontactName.sip_login_id}>

                <div className="dropdowndesign">
                  <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                    profileInfo={
                      (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                        (<>
                          <img src={favcontactName.ImageURL} alt="" />
                          <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                        (<>
                          <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                          <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                        </>)
                    } />
                  <div className="names">{favcontactName.caller_id}</div>
                  <div className="ext">{favcontactName.ext}</div>
                </div>
              </div>;
            })}
              {getrecData.allContacts && getrecData.allContacts.map((user: any, index: any) => {
                  return (
                    <option key={JSON.stringify(user)} value={user?.caller_id ? user?.caller_id : user?.team_name}>
                      {
                  ((getrecData.allContacts[index - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                  ((user?.caller_id)?.charAt(0).toUpperCase()) &&
                  <div className="titlesdrop">{(user?.caller_id)?.charAt(0).toUpperCase()} </div>
                }
                      <div className="dropdowndesign">
                        <div className="usergroupss">
                          <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`} profileInfo={<>
                            {(user.ImageURL || user.profile_image_url) ?
                              <img src={user.caller_id ? user?.ImageURL : user.team_name ? user?.profile_image_url : ""} alt="" /> :
                              <span>{user?.caller_id ? user.caller_id.toUpperCase().charAt(0) : user?.team_name.toUpperCase().charAt(0)}</span>}
                          </>} />
                          <div  className="names">{user?.caller_id ? user?.caller_id : user?.team_name}</div>
                        </div>
                        <div className="ext">{user?.ext ? user.ext : ''}</div>
                      </div>
                    </option>);
                })}
          </Select>
        </div>
        <div className="txtareaDes">
          <Input.TextArea title="Add a message, if you'd like." placeholder="Add a message, if you'd like." onChange={enterMessage} value={getrecData.message}/>
        </div>
        <div className="chatPlayerAudioConsec">
          <div className={styles.videoMsg}>
            {/* <video className="videoFluid" controls={true} preload="metadata">
              <source
                src="https://storage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4" type="video/mp4" />
            </video> */}
          </div>
        </div>
      </Modal>

      <Modal title="Delete Recorded video?"
        centered
        maskClosable={false}
        visible={getrecData.deleteRecordModal}
        onOk={DeleteRecord}
        onCancel={closeSelection}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected Recorded Video?
      </Modal>
    </>
  );
    };

